import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "@/components/PlatformPage";
import { emailAutomation } from "@/lib/integrations-data";
import { buildSeoMeta } from "@/lib/seo";

const PATH = "/integracje/email-automation";

export const Route = createFileRoute("/integracje/email-automation")({
  head: () =>
    buildSeoMeta({
      title: "Email marketing & automation: Klaviyo, Mailchimp, GetResponse | SyncTech",
      description:
        "Wdrożenia email marketingu i automation: Klaviyo, Mailchimp, GetResponse, edrone, ActiveCampaign. Automatyzacje porzuconych koszyków, win-back, welcome flow. ROI 30-40x.",
      path: PATH,
    }),
  component: () => (
    <PlatformPage data={emailAutomation} path={PATH} breadcrumbCategory="Integracje" />
  ),
});
